import React from 'react';
import {Control, UseFormSetValue, UseFormWatch} from 'react-hook-form';
import {RenderAction} from './RenderAction';
import {RenderEmailInput} from './RenderEmailInput';
import {RenderPhoneInput} from './RenderPhoneInput';
import {RenderSelect} from './SelectLists/RenderSelect';
import {RenderText} from './RenderText';
import {FieldTypeEnum, ItemDataFieldModel} from 'models/board/itemData';
import RenderDatePicker from './RenderDatePicker';
import RenderDateTimePicker from './RenderDateTimePicker';
import RenderRadio from './RenderRadio';
import RenderUploadFile from './RenderUploadFile';
import RenderAssignToSelect from './SelectLists/RenderAssignToSelect';
import RenderTextArea from './RenderTextArea';
import RenderTimePicker from './RenderTimePicker';
import RenderTextEditor from './RenderTextEditor';
import RenderNumberField from './RenderNumberField';
import {ItemSummaryVariablesType} from 'global';
import RenderCheckbox from './RenderCheckbox';
import RenderTimeTrackerCounter from './RenderTimeTrackerCounter';
import RenderAppEventTriggersSelect from './SelectLists/RenderAppEventTriggersSelect';
import {RenderIntegrationSelect} from './SelectLists';

export interface FieldsRendererProps {
    field: ItemDataFieldModel;
    control: Control<any, any>;
    setValue: UseFormSetValue<any>;
    indexKey: number;
    watch: UseFormWatch<any>;
    gridSize?: number;
    boardId?: string;
    itemSummaryVariables?: ItemSummaryVariablesType;
    baseFieldName: string;
    itemId?: string;
}

export const FieldsRenderer: React.FC<FieldsRendererProps> = ({boardId, itemId, ...props}) => {
    switch (props.field.fieldType) {
        case FieldTypeEnum.Action:
            return <RenderAction {...props} />;
        case FieldTypeEnum.Email:
            return <RenderEmailInput {...props} />;
        case FieldTypeEnum.Phone:
            return <RenderPhoneInput {...props} />;
        case FieldTypeEnum.SelectList:
            return <RenderSelect {...props} />;
        case FieldTypeEnum.Text:
            return <RenderText {...props} />;
        case FieldTypeEnum.TextArea:
            return <RenderTextArea {...props} />;
        case FieldTypeEnum.AssignTo:
            return <RenderAssignToSelect {...props} />;
        case FieldTypeEnum.Date:
            return <RenderDatePicker {...props} />;
        case FieldTypeEnum.DateTime:
            return <RenderDateTimePicker {...props} />;
        case FieldTypeEnum.Radio:
            return <RenderRadio {...props} />;
        case FieldTypeEnum.UploadFile:
            return <RenderUploadFile itemId={itemId} {...props} />;
        case FieldTypeEnum.Time:
            return <RenderTimePicker {...props} />;
        case FieldTypeEnum.NUMBER:
            return <RenderNumberField {...props} />;
        case FieldTypeEnum.TextEditor:
            return <RenderTextEditor boardId={boardId} {...props} />;
        case FieldTypeEnum.SelectListWithColor:
            return <RenderSelect {...props} />;
        case FieldTypeEnum.CheckBox:
            return <RenderCheckbox {...props} />;
        case FieldTypeEnum.TimeTrackerCounter:
            return <RenderTimeTrackerCounter itemId={itemId} {...props} />;
        case FieldTypeEnum.AppEventTriggersSelect:
            return <RenderAppEventTriggersSelect {...props} />;
        case FieldTypeEnum.IntegrationSelectList:
            return <RenderIntegrationSelect {...props} />;
    }
    return <></>;
};

export default FieldsRenderer;
